import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useNowGeneralContext } from '../../../../now'
import { useProductPageContext } from '../../../components/productPageContext'

import { ProductPageNowDialogDynamicContent } from './ProductPageNowDialogDynamicContent'

export const ProductPageNowDialog: FC = () => {
  const { nowDetails } = useProductPageContext()
  const { productPageNowDialogControls } = useNowGeneralContext()

  return (
    <Dialog
      onClose={productPageNowDialogControls.handleClose}
      open={productPageNowDialogControls.isOpen}
      slotProps={{
        dialog: {
          className: nowDetails.nowCustomerJourneyEnabled
            ? 'w-auto'
            : undefined,
        },
      }}
    >
      <DialogTitle onClose={productPageNowDialogControls.handleClose}>
        {nowDetails.nowCustomerJourneyEnabled ? (
          <FormattedMessage id="now.zip.overlay.title" />
        ) : (
          <FormattedMessage id="now.prompt.headline.deliverytimeAndAvailability" />
        )}
      </DialogTitle>
      <DialogContent
        className={clsx(
          'h-full w-auto',
          nowDetails.nowCustomerJourneyEnabled
            ? 'bg-light-primary-medium p-4 py-6 tablet:p-6'
            : 'bg-light-primary-low tablet:w-[42rem]',
        )}
      >
        <ProductPageNowDialogDynamicContent />
      </DialogContent>
    </Dialog>
  )
}
